
import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ActivatedRoute, Params } from '@angular/router'


@Component({
    template: ` <router-outlet></router-outlet>`,
    

})

export class ContactUsComponent implements OnInit {
    insCo:number
    constructor(private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit(): void {

        this.getParams();
        if (this.insCo !== undefined) {
            this.router.navigateByUrl('/ContactUS/'+this.insCo)
        }

    }

    getParams() {
        console.log('this.params begin')
        this.route.params.forEach((params: Params) => {

            console.log('this.params val' + this.route.snapshot.params["{insCo}"])

            this.insCo = this.route.snapshot.params["{insCo}"]
        })


    }

}
